// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_EMERGENCY_NOTIFICATIONS_SUCCESS,
  GET_EMERGENCY_NOTIFICATIONS_ERROR,
  GET_EMERGENCY_NOTIFICATIONS,
} from "../../constants";
import axios from "../../../../services/api";

function* getEmergencyNoticiations(data) {
  const params = new URLSearchParams();

  if (data.ordering) {
    params.append("ordering", data.ordering);
  }
  if (data.search) {
    params.append("search", data.search);
  }
  if (data.page) {
    params.append("page", data.page);
  }

  try {
    const response = yield call(axios.get, `/emergency-notifications/`, {
      params,
    });
    if (response.data.error) {
      yield put({
        type: GET_EMERGENCY_NOTIFICATIONS_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_EMERGENCY_NOTIFICATIONS_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_EMERGENCY_NOTIFICATIONS_ERROR,
      data: error,
    });
  }
}

export default function* getEmergencyNoticiationsSaga() {
  yield takeLatest(GET_EMERGENCY_NOTIFICATIONS, getEmergencyNoticiations);
}
